import type { RoomSnapshot } from "../models/contracts";
const track = (party: RoomSnapshot) => { const id = party.hostPlayback?.playlistItemId; return party.playlist?.items.find(item => item.id === id) ?? null; };
const present = (value: string | null | undefined): string | null => value?.trim() || null;

export const musicMetadata = (party: RoomSnapshot) => {
  const item = track(party); const playback = party.hostPlayback;
  return {
    title: present(playback?.title) ?? present(item?.title) ?? "Untitled song",
    artist: present(playback?.artist) ?? present(item?.artist),
    artworkUrl: present(playback?.artworkUrl) ?? present(item?.artworkUrl),
    durationMs: playback?.durationMs ?? item?.durationMs,
    momentName: present(party.currentMoment?.displayName),
  };
};

export const playbackPositionMs = (party: RoomSnapshot, serverNow = Date.now()): number => {
  const playback = party.hostPlayback;
  if (!playback) return 0;
  const startAt = playback.startedAt ? Date.parse(playback.startedAt) : Number.NaN;
  const running = playback.status === "Playing"
    || (playback.status === "Scheduled" && (!Number.isFinite(startAt) || serverNow >= startAt));
  if (!running) return playback.positionMs;
  const snapshotAt = Date.parse(party.serverTimeUtc);
  return playback.positionMs + (Number.isFinite(snapshotAt) ? Math.max(0, serverNow - snapshotAt) : 0);
};
export function MusicPresentation({ party, spotlight = false, now }: { party: RoomSnapshot; spotlight?: boolean; now?: number }) {
  const playback = party.hostPlayback; if (!playback) return null;
  const metadata = musicMetadata(party); const progress = metadata.durationMs ? Math.max(0, Math.min(100, playbackPositionMs(party, now) / metadata.durationMs * 100)) : 0;
  return <div class={spotlight ? "music music-spotlight" : "music music-passive"}>{metadata.artworkUrl ? <img class="music-art" src={metadata.artworkUrl} alt="" /> : <div class="music-art fallback">♫</div>}<div class="music-copy">{spotlight && metadata.momentName ? <div class="music-moment"><span>Current moment</span><b dir="auto">{metadata.momentName}</b></div> : null}<span class="eyebrow">Now playing</span><div class="marquee"><strong dir="auto">{metadata.title}</strong></div>{metadata.artist ? <span dir="auto">{metadata.artist}</span> : null}<div class="progress"><i style={{ width: `${progress}%` }} /></div></div></div>;
}
